// extracted by mini-css-extract-plugin
export var callCard = "_qy-0";
export var callMessageButton = "_qy-1";
export var helpIcon = "_qy-3";
export var helpIconContainer = "_qy-4";
export var verticalDivider = "_qy-2";